// extracted by mini-css-extract-plugin
module.exports = {"container":"_bc863b3","withSingleCharacter":"_a29d225"};